import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

export function MarkdownPane({ markdown }: { markdown: string }) {
  return (
    <div className="prose-md h-full overflow-auto p-4">
      <Markdown remarkPlugins={[remarkGfm]}>{markdown}</Markdown>
    </div>
  )
}
